<template>
    <div class="app-content content loginpage_bg  " style="padding:0 !important;">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header row">
            </div>
            <div class="content-body">
                <div class="auth-wrapper auth-v2">
                    <div class="auth-inner row m-0">
                        <a class="brand-logo" href="javascript:void(0);">
                        </a>
                        <!-- /Brand logo-->
                        <!-- Left Text-->
                        <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
                            <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid" src="../../public/images/pages/Illustration 1.svg" alt="Login V2" /></div>
                        </div>
                        <!-- /Left Text-->
                        <!-- Login-->
                        <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-4">
                            <div class="col-16 col-sm-8 col-md-6 col-lg-12 px-xl-0 mx-auto">
                                <div class="m-auto text-center d-block">
                                <img alt="" class="card-title font-weight-bold mb-1" src="../../public/images/logo/IntelliBee-Logo.png"  height="70px"> 
                                </div>
                                <p class="card-text mb-2 ml-0">Please sign-in to your account and start the adventure</p>
                                <form class="auth-login-form mt-2" style="padding-right: 6px;" @submit.prevent="handleSubmit">
                                    <div class="form-group">
                                        <label class="form-label" for="login-email">Staff ID</label>
                                        <input class="form-control" id="login-email" type="text"  v-model="email" placeholder="user@firstcry.com" aria-describedby="login-email" autofocus="true" tabindex="1"   />
                                    </div>
                                    <div class="form-group">
                                        <div class="d-flex justify-content-between">
                                            <label for="login-password">Password</label></a>
                                        </div>
                                        <div class="input-group input-group-merge form-password-toggle">
                                            <input class="form-control form-control-merge" id="login-password"  v-model="password" v-if="showPassword" type="text"  placeholder="············" aria-describedby="login-password" tabindex="2" v-bind:class="{'form-control':true, 'is-invalid' : !validPassword(password) && passwordBlured}" v-on:blur="passwordBlured = true"/>
                                            <input class="form-control form-control-merge" id="login-password" v-model="password" v-else  type="password"  placeholder="············" aria-describedby="login-password" tabindex="2" v-bind:class="{'form-control':true}" />
                                                <div class="input-group-append" @click="toggleShow"><span class="input-group-text cursor-pointer">
                                                <eye-icon v-if="showPassword" size="1.5x" class="custom-class"></eye-icon>
                                                <eye-off-icon v-if="!showPassword" size="1.5x" class="custom-class"></eye-off-icon>
                                                </span>
                                                </div>
                                        </div>
                                    </div>
                                   
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" id="remember-me" type="checkbox" tabindex="3" />
                                            <label class="custom-control-label" for="remember-me"> Remember Me!</label>
                                        </div>
                                    </div>
                                    <!-- <div class="formCaptcha">
                                        <div class="text-right d-flex">
                                            <my-captcha :callSuccess="captchaBtn"></my-captcha>
                                            <button class="buttonCaptcha" v-bind:disabled="btndis" v-on:click="clicked">Submit</button>
                                        </div>
                                    </div> -->

                                    <button type="submit" v-bind:disabled="!email || !password" class="btn btn-primary btn-block loginBtn" style="margin-top: 10px;">
                                        <vue-element-loading
                                          :active="isLoggingIn"
                                          spinner="bar-fade-scale"
                                          color="#5bbdeb"
                                        />Log in
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { EyeIcon } from 'vue-feather-icons'
import { EyeOffIcon } from 'vue-feather-icons'
import VueElementLoading from "vue-element-loading";
import common_methods from "../utils/common_methods";
import myCaptcha from 'vue-captcha'

export default ({
    name:'Login_old',
    mixins: [common_methods],
    components: {
        EyeIcon,
        EyeOffIcon,
        VueElementLoading,
        myCaptcha
    },
    data(){
        return{
            email:'',
            password:'',
            dbclient:'1',
            emailBlured : false,
            valid : true, 
            submitted : false,
            passwordBlured:false,
            showPassword: false,
            btndis: false,
            captcha_res: '',
            isLoggingIn: false,
        }
        
    },
    computed: {
        buttonLabel() {
            return (this.showPassword) ? "Hide" : "Show";
        }
    },
    mounted(){
        localStorage.removeItem('reloaded');
        localStorage.removeItem('userdata');
        localStorage.removeItem('token');
        localStorage.removeItem('check');
        localStorage.removeItem('pagefeatures');
        localStorage.removeItem('sidebar');
        localStorage.removeItem('travel');
    },
    methods:{
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        validate : function(){
            this.emailBlured = true;
            this.passwordBlured=true;
            if( this.validEmail(this.email) && this.validPassword(this.password)){
                this.valid = true;
            }
        },
        validEmail : function(email) {
            var re = /(.+)@(.+){2,}\.(.+){2,}/;
            return re.test(email.toLowerCase());
        },
        validPassword : function(pasword) {
           var re = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{1,})/;
            return re.test(pasword);
        },
        async handleSubmit(){
            // this.validate(); 
            if(this.valid){
                this.submitted = true;
            }
            if(this.submitted){
                this.isLoggingIn = true;
                try {
                    const response = await  axios.post('/user/login',{
                        username:this.email,
                        password:this.password,
                    });
                    let responseMsg = response?.data?.msg ?? response?.data?.message ?? "Fail to log in"
                          
                    if(responseMsg == "Login successfully"){
                        var details = response.data.data
                        var pagefeatures = []
                        var sidebarData = []
                        // let sidebararr = details.access['menudetail']
                        // let pageroutes = details.access['pageroutedetail']
                        // let defaultPage = pageroutes.filter(item => item.defaultpage == true)
                        var finalcheck = []
                        // for (let i = 0; i <pageroutes.length; i++) {
                        //     if(pageroutes[i].pagefeatures.length > 0){
                        //         pageroutes[i].pagefeatures.forEach(element => {
                        //         pagefeatures.push({page: pageroutes[i].pageroute.replace(/\s+/g, '').toLowerCase(), featurename: element.featurename, featureaccess: element.featureaccess.c === 'Y'})
                        //         })
                        //     }
                        // }
                        
                        // for (let i = 0; i <sidebararr.length; i++) {
                        //     if(sidebararr[i].pagefeatures.length > 0){
                        //         sidebararr[i].pagefeatures.forEach(element => {
                        //         pagefeatures.push({page: sidebararr[i].menuname.replace(/\s+/g, '').toLowerCase(), featurename: element.featurename, featureaccess: element.featureaccess.c === 'Y'})
                        //         })
                        //     }
                        //     let parentmenu = ''
                        //     parentmenu = sidebararr[i].menuname
                        //     let childmenu = ''
                        //     var children = []
                        //     if (sidebararr[i].submenu) {
                        //         childmenu = sidebararr[i].submenu
                        //         if (childmenu.length > 0) {
                        //             for (let j = 0; j < childmenu.length; j++) {
                        //                 finalcheck.push('#/'+parentmenu+'/'+childmenu[j].pagename.split('/')[2])
                        //                 children.push({
                        //                     'name': childmenu[j].menuname,
                        //                     'url': childmenu[j].pagename,
                        //                     'icon': childmenu[j].iconname
                        //                 })
                        //             }
                        //         }
                                    
                        //     }
                        //     sidebarData.push({
                        //     name: parentmenu,
                        //         'url':  sidebararr[i].pagename,
                        //         'icon': sidebararr[i].iconname,
                        //         'children': children
                        //     })
                        //     console.log(sidebarData, '----sidebarData')
                        //     console.log(finalcheck, '--finalcheck-')
                        //     console.log(pagefeatures, '---pagefeatures')
                        //     if (i == sidebararr.length-1) {
                        //         localStorage.setItem('sidebar',window.btoa(JSON.stringify(sidebarData)));
                        //         localStorage.setItem('check',window.btoa(JSON.stringify(finalcheck)));
                        //         localStorage.setItem('pagefeatures',window.btoa(JSON.stringify(pagefeatures)));
                                
                        //     } 
                        // }
                        sidebarData = [
                            {
                                "name": "my dashboard",
                                "url": "mydashboard",
                                "icon": "home-icon",
                                "children": []
                            },
                            {
                                "name": "travel request",
                                "url": "travelrequest",
                                "icon": "briefcase-icon",
                                "children": []
                            },
                            {
                                "name": "my approval",
                                "url": "/viewrequest",
                                "icon": "book-icon",
                                "children": []
                            },
                            {
                                "name": "admin panel",
                                "url": "/adminpanalviewtickets",
                                "icon": "users-icon",
                                "children": []
                            },
                            {
                                "name": "reports",
                                "url": "/reports",
                                "icon": "file-icon",
                                "children": []
                            },
                            {
                                "name": "master",
                                "url": "/hodmaster",
                                "icon": "settings-icon",
                                "children": [
                                    {
                                        "name": "mode of transport",
                                        "url": "/transportmodemaster",
                                        "icon": "grid-icon"
                                    },
                                    {
                                        "name": "hod master",
                                        "url": "/hodmaster",
                                        "icon": "grid-icon"
                                    },
                                    {
                                        "name": "designation band master",
                                        "url": "/designationbandmaster",
                                        "icon": "grid-icon"
                                    },
                                    {
                                        "name": "manager master",
                                        "url": "/ticketapprovalmaster",
                                        "icon": "grid-icon"
                                    }
                                ]
                            },
                            {
                                "name": "payment generation",
                                "url": "/finwise",
                                "icon": "grid-icon",
                                "children": []
                            },
                            {
                                "name": "ticket approval",
                                "url": "/hodtravelreqlist",
                                "icon": "settings-icon",
                                "children": []
                            },
                            {
                                "name": "invoice report",
                                "url": "/paymentinvoicereport",
                                "icon": "grid-icon",
                                "children": []
                            }
                        ]
                        finalcheck = [
                            "#/master/undefined",
                            "#/master/undefined",
                            "#/master/undefined",
                            "#/master/undefined"
                        ]
                        localStorage.setItem('sidebar',window.btoa(JSON.stringify(sidebarData)));
                        localStorage.setItem('check',window.btoa(JSON.stringify(finalcheck)));
                        localStorage.setItem('pagefeatures',window.btoa(JSON.stringify(pagefeatures)));
                        localStorage.setItem('token',response.data.data.accessToken);
                        localStorage.setItem('userdata',JSON.stringify(response.data.data));
                        if(this.email == 'prashant@intellibees.com' || this.email ==  'nikhil@intellibees.in2'){
                            this.$router.push('/controlltower')
                            // this.$router.push('/mydashboard')
                        } else {
                            this.$router.push('/mydashboard')
                        }
                    } else {
                        let message = response.data.message ?? response.data.msg ?? "Something Went wrong!"
                        this.sweetAlertSnackbar(message, "error");
                    }
                } catch(e) {
                    this.isLoggingIn = false;
                    let message = "Something went wrong. ";
                    if (e?.response?.data.message) {
                        message = e.response.data.message;
                    }
                    this.sweetAlertSnackbar(message, "error", "top-right");
                }
            }
        },
        
        // recaptchaVerified(response) {
        //     console.log("recaptchaVerified response::")
        //     console.log( response )
        //     this.captcha_res = response
        //     this.btndis = false
        // },

        // recaptchaExpired() {
        //     console.log("CAPTCHA Has Expired")
        //     this.captcha_res = ''
        //     this.btndis = true
        // },

        captchaOk() {
        },

        captchaBtn() {
            this.btndis = false
        },

        clicked() {},
        }
})
</script>

<style scoped>
   .buttonCaptcha{
    display:none;
   }
   .vue-captcha{
    margin: 0px auto!important;
     border: 1px solid #ddd!important;
    border-radius: 3px;
   }

   .form-group .rc-anchor-content {
    height: 74px;
    width: 60%!important;
}
.auth-login-form .input-group-append .input-group-text.cursor-pointer{
    border-top-right-radius: 5px!important;
    border-bottom-right-radius: 5px!important;
}
.loginpage_bg{
     background: #f9f9f9;
}
.app-content.content.loginpage_bg{
  margin-left: 0px!important;
}

.loginBtn[disabled] {
  color: #fff !important;
  font-weight: 600;
  padding: 7px 10px;
  font-size: 1rem;
  border-radius: 4px;
  width: 100%
}

.loginBtn[disabled]:hover {
  color: #fff;
  background-color: #34b0cb;
  border-color: #31a7c1;
}

.login_view_full .loginBtn {
  width: 100%;
  padding: 7px 10px;
  font-size: 1rem;
  color: #fff !important;
  font-weight: 600;
}

</style>